module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.12/_next/static/images/selo-sem-luz-desk-3dc65a99a63d6c5eaaeed8250ff83990.webp";